export const changelog = {
  title: 'Notes de version',
  panels: {
    added: 'Nouveau',
    changed: 'Modifié',
    deprecated: 'Déprécié',
    removed: 'Supprimé',
    fixed: 'Corrigé',
    security: 'Sécurité',
    quasarVersion: 'Version de Quasar utilisée : {quasarVersion}',
    quasarAppVersion: 'Version de Quasar/app utilisée : {quasarAppVersion}',
  },
  warning:
    "Impossible de recharger la page car l'application semble être hors ligne.",
};
